/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Tables_P1Inputs */

const en_wc_tut_tables_p1 = /** @type {(inputs: Wc_Tut_Tables_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert → Table lets you drag out a grid. Table styles add banded rows; header rows repeat on every page. You can merge and split cells, sort rows and convert text to a table.`)
};

/**
* | output |
* | --- |
* | "Insert → Table lets you drag out a grid. Table styles add banded rows; header rows repeat on every page. You can merge and split cells, sort rows and convert..." |
*
* @param {Wc_Tut_Tables_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_tables_p1 = /** @type {((inputs?: Wc_Tut_Tables_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Tables_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_tables_p1(inputs)
});
export { wc_tut_tables_p1 as "wc.tut.tables.p1" }